<template>
  <div>
    <b-navbar
      class="topbar"
      type="dark"
      variant="primary"
    >
      <div
        style="margin-left:0.8925rem; cursor:pointer;"
        class="mr-3 d-inline-block"
      >
        <b-img
          src="@/assets/logo_smart_tv_analytics.png"
          class="w-100"
          @click.exact="goToHome"
        />
      </div>
      <NavLeftMenu />
      <b-modal
        id="modal-user"
        ref="loginUserModal"
        centered
        size="xl"
        title="Temp Login As You/Another User"
        @ok="handleOk"
      >
        <template #modal-footer>
          <b-button
            @click="hideModal()"
          >
            Close
          </b-button>
          <b-button
            :disabled="!tempRegisteredDateTime && !valueCurrUser"
            variant="primary"
            @click="handleOk()"
          >
            Ok
          </b-button>
        </template>
        <b-row>
          <b-col
            class="custom-text"
            style="text-align: center;
            align-self: center;font-size: medium;font-weight: 900"
          />
        </b-row>
        <b-row>
          <b-col
            class="custom-text"
            style="text-align: center;
            align-self: center;font-size: medium;"
          >
            Login as You
          </b-col>
          <b-col>
            <multiselect
              v-model="valueCurrUser"
              :options="optionsCurrentUser"
              :custom-label="mailWithGuidCurrUser"
              placeholder="Select your ID"
              track-by="email"
              select-label=""
              selectedLabel=""
              deselect-label=""
              @input="tempRegisteredDateTime=undefined;
                      invalidRegisteredDateTime=false;"
            >
              <span
                slot="option"
                slot-scope="scope"
                class="container"
              >
                <span
                  id="span_id"
                  style="margin-left: 0.5rem"
                >
                  {{ scope.option.email }}
                </span>
              </span>
            </multiselect>
          </b-col>
        </b-row>
        <b-row class="my-4">
          <b-col
            class="custom-text"
            style="text-align: center;
            align-self: center;font-size: medium;font-weight: 900"
          >
            -OR-
          </b-col>
        </b-row>
        <b-row>
          <b-col
            class="custom-text"
            style="text-align: center;
            align-self: center;font-size: medium;"
          >
            Login through Registered Date Time
          </b-col>
          <b-col>
            <b-input-group size="sm">
              <b-form-input
                id="guid-input"
                v-model="tempRegisteredDateTime"
                type="search"
                placeholder="Enter Registered Date Time"
                style="border-radius: 5px;font-size: 1.2rem;"
                @input="valueCurrUser='';"
              />
            </b-input-group>
            <div
              v-if="invalidRegisteredDateTime"
              style="color: red"
            >
              Invalid registered date time. Please enter a correct value.
            </div>
          </b-col>
        </b-row>
      </b-modal>
      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown
          v-if="isAdmin"
          id="login_as_another_user"
          :text="computedUserName"
          class="admin-over-dropdown admin-dropdown"
          menu-class="shadow animated--grow-in minw-20r rounded-sm border"
        >
          <b-dropdown-item
            class="login-user-dropdown admin-dropdown"
            @click="displayModel()"
          >
            <span>
              Click to Login as Another User
            </span>
          </b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item
          class="usage-dropdown"
          href="/contact"
          target="popup"
          @click.prevent="openContactPopup"
        >
          Contact
        </b-nav-item>
        <b-nav-item-dropdown
          v-if="isAdmin"
          id="cp_admin"
          right
          text="Admin"
          class="admin-dropdown admin-over-dropdown"
          menu-class="shadow animated--grow-in minw-12_5r rounded-sm border"
        >
          <b-dropdown-item
            class=" usage-dropdown"
            :to="{
              path: '/user_info',
              name: 'UserInfoPage',
              meta: {
                layout: 'HomeLayout',
                user_info_route: true,
              },
            }"
          >
            <span @click="removeSideBarFocus">
              User Info
            </span>
          </b-dropdown-item>
          <b-dropdown-item
            class=" usage-dropdown"
            :to="{
              path: '/group',
              name: 'GroupPage',
              meta: {
                layout: 'HomeLayout',
              },
            }"
          >
            <span @click="removeSideBarFocus">
              Group Info
            </span>
          </b-dropdown-item>
          <b-dropdown-item
            id="admin_permission_management"
            class=" usage-dropdown"
            :to="{
              path: '/permission',
              name: 'Permission',
              meta: {
                layout: 'HomeLayout',
                user_info_route: false,
              },
            }"
          >
            <span @click="removeSideBarFocus">
              Permission Management
            </span>
          </b-dropdown-item>
          <b-dropdown-item
            class=" usage-dropdown"
            :to="{
              path: '/usage',
              name: 'UsagePage',
              meta: {
                layout: 'HomeLayout',
              },
            }"
          >
            <span @click="removeSideBarFocus">
              User and usage statistics
            </span>
          </b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown
          right
          text="My Account"
          class="myaccount-dropdown"
          menu-class="shadow animated--grow-in minw-12_5r rounded-sm border"
        >
          <!-- Using 'button-content' slot -->
          <b-dropdown-item
            class=" usage-dropdown"
            @click="logout()"
          >
            Sign Out
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-navbar>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import multiselect from 'vue-multiselect';
import storageLocal from '@/api/storage/local';
import { getOtherUserDetails } from '@/api/permission/permission';
import EventSanitizer from '@/utils/EventSanitizer';
import { isUserAdminCheck, logoutSAAccount } from '@/api/auth/auth';
import logoutUtil from '@/utils/LogoutUtil';
import NavLeftMenu from './NavLeftMenu';

export default {
  components: {
    NavLeftMenu,
    multiselect,
  },
  props: {
    menu: {
      type: Boolean,
      default: false,
    },
    home: {
      type: Boolean,
      default: false,
    },
    guid: {
      type: Boolean,
      default: false,
    },
    account: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      optionsCurrentUser: [],
      isAdmin: false,
      headerTextVariant: 'light',
      valueCurrUser: '',
      isLoading: false,
      tempRegisteredDateTime: undefined,
      invalidRegisteredDateTime: false,
    };
  },
  computed: {
    ...mapGetters('user', {
      isLoggedIn: 'isLoggedIn',
      hasAgreed: 'hasAgreed',
      isSysAdmin: 'isSysAdmin',
      userProfile: 'userProfile',
    }),
    computedUserName() {
      if (this.userProfile.tempRegisteredDateTime !== undefined) {
        return 'Viewing App As Another User';
      }
      return 'Viewing App As Self';
    },
  },
  async created() {
    let tempUserAdmin;
    try {
      tempUserAdmin = await isUserAdminCheck();
    } catch (error) {
      console.log(error);
    }
    if (tempUserAdmin.isAdmin) {
      this.isAdmin = true;
      if (this.userProfile.fillAllUserDetails !== 'filled') {
        const profile = this.userProfile;
        profile.showExplorePopup = false;
        profile.fillAllUserDetails = 'filled';
        this.setUserProfile(profile);
        this.isLoading = true;
        // this.addOtherUsers();
      } else {
        this.isLoading = true;
      }
      this.isLoading = false;
      this.optionsCurrentUser = [];
      this.optionsCurrentUser.push({
        email: this.userProfile.id,
        guid: this.userProfile.guid,
        role: 'a',
      });
      // eslint-disable-next-line max-len
      if (!this.userProfile.tempRegisteredDateTime) {
        this.valueCurrUser = [{
          email: this.userProfile.id,
          guid: this.userProfile.guid,
          role: 'a',
        }];
      } else {
        this.valueCurrUser = '';
      }
    }
  },
  methods: {
    ...mapActions('user', {
      setFocusOnSidebar: 'setFocusOnSidebar',
      setOtherUserDetails: 'setOtherUserDetails',
      setUserProfile: 'setUserProfile',
    }),
    hideModal() {
      this.$refs.loginUserModal.hide();
    },
    handleOk() {
      this.setFocusOnSidebar(false);

      // eslint-disable-next-line max-len
      if (!this.tempRegisteredDateTime || this.validateDatetime(this.tempRegisteredDateTime)) {
        this.invalidRegisteredDateTime = false;
      } else {
        this.invalidRegisteredDateTime = true;
        return;
      }

      const profile = this.userProfile;
      profile.showExplorePopup = false;
      profile.fillAllUserDetails = 'filled';
      if (this.valueCurrUser) {
        profile.tempRegisteredDateTime = undefined;
        this.setUserProfile(profile);
      } else {
        profile.tempRegisteredDateTime = this.tempRegisteredDateTime;
        this.setUserProfile(profile);
      }

      this.$refs.loginUserModal.hide();
      if (this.$router.currentRoute.path !== '/') this.$router.push('/');
    },
    mailWithGuidCurrUser({ email, guid, role }) {
      return email;
    },
    async addOtherUsers() {
      const data = [];
      // eslint-disable-next-line max-len
      const cleanValue = EventSanitizer.sanitizeValue(this.$sanitize(this.userProfile.guid));
      const res = await getOtherUserDetails(cleanValue);
      for (let i = 0; i < res.users.length; i++) {
        data.push({
          email: res.users[i].email,
          guid: res.users[i].guid,
          role: res.users[i].role,
        });
      }
      this.setOtherUserDetails(data);
    },
    displayModel() {
      this.$refs.loginUserModal.show();
    },
    async logout() {
      const ssoState = storageLocal.getState();
      logoutUtil.logout();
      const res = await logoutSAAccount(ssoState);
      console.log(ssoState, res);
      window.location.href = res;
    },
    removeSideBarFocus() {
      this.setFocusOnSidebar(false);
    },
    openContactPopup() {
      window.open('/contact', 'popup', 'width=700,height=500');
    },
    goToHome() {
      this.$router.push({ path: '/' });
      this.removeSideBarFocus();
    },
    validateDatetime(datetimeString) {
      // Create a Date object to validate the date and time
      const date = new Date(datetimeString);

      // Check if the created Date object is valid
      return !Number.isNaN(date.getTime());
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang = "scss">
@import '~@/styles/variables.scss';
.navbar-brand{
  position: absolute;
  font-size: 1.5rem !important;
  font-weight: 800;
  left: 53px !important;
}
.usage-dropdown {
  .dropdown-menu {
      display: none !important;
  }
  .nav-link{
    margin-right:1.5rem !important;
  }
}
.login-user-dropdown{
  .dropdown-menu {
      display: none !important;
  }
  .nav-link{
    margin-right:1.5rem !important;
  }
}
.login-user-dropdown a{
  font-size: inherit !important;
}
.myaccount-dropdown {
    .dropdown-menu {
        width: 12rem !important;
        .dropdown-item {
          &:hover {
           width : 8.8rem !important;
          }
        }
    }
    .nav-link{
      margin-right: 2.5rem !important;
    }
}
.admin-dropdown {
    .dropdown-menu {
        width: 12rem !important;
        .dropdown-item {
          &:hover {
           width : 8.8rem !important;
          }
        }
    }
    .nav-link{
      margin-right: 2.5rem !important;
    }
}
.admin-over-dropdown {
    .dropdown-menu {
        width: 13.5rem !important;
        .dropdown-item {
          &:hover {
           width : 10.3rem !important;
          }
        }
        .rightDropdown{
          margin-left: 0.1rem !important;
          width: 9.5rem !important;
          .dropdown-item {
            &:hover {
              width : 6.3rem !important;
            }
          }
        }
        .userManual{
          margin-left: 0.1rem !important;
          width: 11.7rem !important;
          .dropdown-item {
            &:hover {
              width : 8.5rem !important;
            }
          }
        }
    }
}
.modal-title {
    margin-bottom: 0;
    line-height: 1.5;
    font-weight: 800;
}
.multiselect{
  width: 100% !important;
}
custom-text{
  position: relative;
    display: inline-block;
    min-height: 20px;
    line-height: 20px;
    border: none;
    border-radius: 5px;
    background: #fff;
    padding: 0 0 0 5px;
    width: 100%;
    transition: border .1s ease;
    box-sizing: border-box;
    margin-bottom: 8px;
    vertical-align: top;
    padding-left: 5px;
}
.toggle_button {
  float: center;
  position: relative;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  border-radius: 0rem;
  margin-right: 1rem;
}

.modal-header {
    background-color: #e7efff;
    align-content: center;
    padding: .85rem 1.25rem .25rem 1.25rem!important;
}

.multiselect__option--highlight {
  background: #0747A6;
  &:after {
    background :#0747A6;
  }
}

.multiselect__option--selected {
    background:lightgray;
    color:#35495e;
    &:after {
      color:#35495e;
    }
}

.multiselect__option--selected.multiselect__option--highlight {
    background: darkgray;
    &:after {
      background:darkgray;
      color:#fff;
    }
}
</style>
<style scoped>
.was-validated .form-control:valid, .form-control.is-valid {
  border-color: #d1d3e2 !important;
  background-image: none !important;
}
.was-validated .form-control:invalid, .form-control.is-invalid{
  background-image: none !important;
}
/* Hide the browser's default checkbox */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 30%;
  left: 1rem;
  height: 40%;
  width: 15px;
  background: white;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background: white;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: #0747A6;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
  /* left: 9px;
  top: 5px;
  width: 5px;
  height: 10px; */
  top: 15%;
  left: 30%;
  height: 30%;
  width: 5%;
  border: solid white;
  border-width: 0 2.35px 2.35px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>
